import { useEffect, useRef } from 'react';

export default function CursorSpotlight() {
  const ref = useRef(null);
  const target = useRef({ x: -1000, y: -1000 });
  const current = useRef({ x: -1000, y: -1000 });
  const raf = useRef(0);

  useEffect(() => {
    function onMove(e) {
      target.current = { x: e.clientX, y: e.clientY };
    }
    window.addEventListener('mousemove', onMove);

    function tick() {
      const ease = 0.14;
      current.current.x += (target.current.x - current.current.x) * ease;
      current.current.y += (target.current.y - current.current.y) * ease;
      if (ref.current) {
        ref.current.style.background = `
          radial-gradient(420px circle at ${current.current.x}px ${current.current.y}px, rgba(255,84,74,.13), transparent),
          radial-gradient(160px circle at ${current.current.x}px ${current.current.y}px, rgba(0,240,255,.10), transparent)
        `;
      }
      raf.current = requestAnimationFrame(tick);
    }
    raf.current = requestAnimationFrame(tick);

    return () => {
      window.removeEventListener('mousemove', onMove);
      cancelAnimationFrame(raf.current);
    };
  }, []);

  return <div ref={ref} className="fixed inset-0 z-0 pointer-events-none" />;
}
